import React, { CSSProperties, ReactNode } from 'react';
import { checkValidKey } from '../util/util';
import { debounce } from 'lodash';

interface ClickableProps {
  children: ReactNode;
  onClick: () => void;
  style?: CSSProperties;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  validKeys?: number[];
}

const Clickable: React.FC<ClickableProps> = ({
  children,
  onClick,
  style,
  className,
  disabled,
  validKeys,
}) => {
  const debouncedOnClick = debounce(onClick, 250, {
    leading: true,
    trailing: false,
  });
  const onKeyPress = (e: any) => {
    if (!onClick) return;
    if (checkValidKey(e.keyCode, validKeys)) {
      debouncedOnClick();
    }
  };

  return (
    <button
      type="button"
      style={style}
      className={className}
      disabled={disabled}
      onClick={debouncedOnClick}
      onKeyPress={onKeyPress}
    >
      {children}
    </button>
  );
};

export default Clickable;
